import Vue from 'vue';

/**
 * @deprecated Use emitter instead
 */
export const eventBus = new Vue();
